/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/quotes */
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { AddEditCategoryComponent } from "./add-edit-category/add-edit-category.component";
import { CategoryService } from "./category.service";
const COLS = [
  { value: "catNameEng", lowercaseValue: "catNameEng", displayName: "Category Name (English)" },
  { value: "catNameMar", lowercaseValue: "catNameMar", displayName: "Category Name (मराठी)" },
];

export interface PeriodicElement {
  catNameEng: string;
  catNameMar: number;
  pkCatid: number;
}

const ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: "app-category",
  templateUrl: "./category.component.html",
  styleUrls: ["./category.component.scss"],
})
export class CategoryComponent implements OnInit, AfterViewInit {
  displayedCols = COLS;
  allCols = COLS;
  displayedColumns: any[];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  constructor(public dialog: MatDialog, private categoryService: CategoryService, private _snackBar: MatSnackBar) {}

  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.displayedCols = [
      { value: "catNameEng", lowercaseValue: "catNameEng", displayName: "Name" },
      { value: "catNameMar", lowercaseValue: "catNameMar", displayName: "Weight" },
    ];

    this.displayedColumns = this.displayedCols.map((col) => col.value);

    this.getCategories();
  }

  async getCategories() {
    this.dataSource = new MatTableDataSource();
    const response: any = await this.categoryService.getCategories();
    if (!response.error) {
      if (response.length > 0) {
        this.dataSource = new MatTableDataSource(response);
        this.dataSource.paginator = this.paginator;
      } else {
        this.warningToast();
      }
    } else {
      this.errorToast();
    }
  }

  addNewCategory() {
    const dialogRef = this.dialog.open(AddEditCategoryComponent, {
      panelClass: ["custom-popup"],
      width: "50%",
      disableClose: true,
      data: ["New"],
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "success") {
        this.getCategories();
      }
    });
  }

  editCategory(data: any) {
    console.log(data);
    const dialogRef = this.dialog.open(AddEditCategoryComponent, {
      panelClass: ["custom-popup"],
      width: "50%",
      disableClose: true,
      data: ["Edit", data],
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "success") {
        this.getCategories();
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async warningToast() {
    await this._snackBar.open("No categories available.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast() {
    await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
